<ng-container *transloco="let t; read: 'blog-v240'">
  <h1>{{ t("title") }}</h1>
  <section class="article">
    <article>
      <div class="text">
        <p>{{ t("feature-shadow") }}</p>
        <img
          src="assets/text_frame.png"
          alt="Text mit Rahmen"
          style="width: 276px"
        />
        <p>
          {{ t("feature-riva-import") }}
        </p>
        <img
          src="assets/v24_start.png"
          alt="Startbildschirm der Version 2.4"
          style="width: 600px"
        />
      </div>
      <a [routerLink]="['/blog']" class="call">{{ t("back-to-blog") }}</a>
    </article>
  </section>
</ng-container>
